import React, { useEffect, useState, useRef, useCallback } from "react";
import "../Auth/auth.css";
import AuthAside from "../Auth/AuthAside";
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Paper,
  Divider,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { encryptMessages, showToast, WEBSERVICE, handleDefaultAssetPair } from "../../CoreDataService";
import { useChat } from "../../Services/ChatService";
import { useOtp } from "../../Contexts/OtpContext";

const Otp = () => {
  const { sendSmartMobileOtp } = useOtp();
  const { makeUserOnline } = useChat();
  const navigate = useNavigate();
  const { brokerBasicInfo, brokerDetailedInfo } = useSelector((state) => state);
  const [countdown, setCountdown] = useState(300);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [showPhoneNumber, setShowPhoneNumber] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors, isSubmitting },
  } = useForm();

  const emailcode = watch("emailcode");
  const phoneOtp = watch("phoneOtp");
  const lastSubmittedOtp = useRef("");

  useEffect(() => {
    if (countdown > 0) {
      const timer = setInterval(() => setCountdown((prev) => prev - 1), 1000);
      return () => clearInterval(timer);
    }
  }, [countdown]);

  useEffect(() => {
    setPhoneNumber(localStorage.getItem("phoneUsedForRegistration"));
    setShowPhoneNumber(localStorage.getItem("phoneNumberActiveStatus") === "1");
  }, []);

  const backgroundStyle =
    brokerDetailedInfo?.color?.isBackgroundImage === 0
      ? {
        background: `linear-gradient(90deg, ${brokerDetailedInfo?.color?.backgroundColor1} 0%, ${brokerDetailedInfo?.color?.backgroundColor2} 60%)`,
      }
      : {
        backgroundImage: `url(${brokerDetailedInfo?.color?.backgroundImageLink})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      };

  const isRequesting = useRef(false);

  const setLoginData = useCallback(
    async (data) => {
      const accessToken = data.token;
      const uuid = data.userResult.uuid;

      localStorage.setItem("access_token", accessToken);
      localStorage.setItem("uuid", uuid);

      const userObj = { userId: data.userResult.userId, uuid };
      const userJsonString = JSON.stringify(userObj);

      const response = await axios.post(
        `${WEBSERVICE}user/GetUserDetails`,
        userJsonString,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${accessToken}`,
          },
        }
      );

      const dataRecheck = response.data;
      if (dataRecheck.error.error_data === 0) {
        const userDetails = dataRecheck.userResult;
        const myDate = new Date();
        myDate.setMonth(myDate.getMonth() + 12);

        document.cookie = `Username=${userDetails.firstName};expires=${myDate};domain=.paybito.com;path=/`;
        document.cookie = `userId=${userDetails.userId};expires=${myDate};domain=.paybito.com;path=/`;
        document.cookie = `ssecca=${accessToken};expires=${myDate};domain=.paybito.com;path=/`;

        localStorage.setItem("user_name", userDetails.firstName);
        localStorage.setItem("email", userDetails.email);
        localStorage.setItem("profile_pic", userDetails.profilePic);
        localStorage.setItem(
          "tier2SubmissionDate",
          userDetails.tier2SubmitDate || ""
        );
        localStorage.setItem(
          "tier3SubmissionDate",
          userDetails.tier3SubmitDate || ""
        );
        localStorage.setItem(
          "tier2ApprovedDate",
          userDetails.tier2ApprovedDate || ""
        );
        localStorage.setItem(
          "tier3ApprovedDate",
          userDetails.tier3ApprovedDate || ""
        );

        localStorage.setItem("user_name", userDetails.firstName);
        localStorage.setItem("first_name", userDetails.firstName);
        localStorage.setItem("last_name", userDetails.lastName);
        localStorage.setItem("middle_name", userDetails.middleName);
        localStorage.setItem("user_id", userDetails.userId);
        localStorage.setItem("userId", userDetails.userId);
        // document.cookie = cookieName1 + "=" + userDetails.userId + ";expires=" + myDate + ";domain=.paybito.com;path=/";
        localStorage.setItem("email", userDetails.email);
        localStorage.setItem("profile_pic", userDetails.profilePic);
        localStorage.setItem("check_id_verification_status", "true");
        const pair = dataRecheck?.defaultAssetPair || dataRecheck?.userResult?.defaultAssetPair;
        if (pair) {
          handleDefaultAssetPair(pair, true);
        } else {
          localStorage.setItem("selected_currency", "btc");
          localStorage.setItem("buying_crypto_asset", "btc");
          localStorage.setItem("O_buying_crypto_asset", "btc");
          localStorage.setItem("selling_crypto_asset", "usdt");
          localStorage.setItem("O_selling_crypto_asset", "usdt");
        }
        localStorage.setItem("UserTiretype", userDetails.userTierType);
        localStorage.setItem("exist2FaKey", userDetails.exist2FaKey);
        localStorage.setItem("userCountry", userDetails.country);
        if (localStorage.getItem("BROKERID") === userDetails.brokerId) {
          console.log("");
        } else {
          // console.log("brokerId--> 5", userDetails.brokerId);
          localStorage.setItem("BROKERID", userDetails.brokerId);
        }

        navigate("/identity-verification");
      } else {
        showToast("error", "Unable to fetch user details.");
      }
    },
    [navigate]
  );

  const callFcmTokenRegister = useCallback(async (token, uuid) => {
    console.log("in calling fcm token");

    const userObj = {
      platform: "WEB",
      uuid: uuid,
      token: localStorage.getItem("fcmToken"),
      audience: "TRADER",
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}notification/updateFCMToken`,
        JSON.stringify(userObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + token,
          },
        }
      );

      console.log("FCM token registered:", response.data);
    } catch (error) {
      console.error("Error registering FCM token:", error);
    }
  }, []);

  const onSubmit = useCallback(
    async (data) => {
      if (isRequesting.current) return;
      isRequesting.current = true;
      const payload = {
        brokerId: brokerBasicInfo.brokerId,
        email: localStorage.getItem("emailForUser"),
        otp: data.emailcode,
        userId: localStorage.getItem("userId"),
      };
      if (showPhoneNumber) {
        payload.phoneOtp = data.phoneOtp;
      }

      try {
        const response = await axios.post(
          `${WEBSERVICE}user/CheckOTP`,
          payload
        );
        if (response?.data?.error?.error_data === 0) {
          showToast("success", "OTP verified successfully");
          localStorage.setItem(
            "signup_user_id",
            response?.data?.userResult.user_id
          );
          const res = response?.data;

          callFcmTokenRegister(res?.token, res?.userResult?.uuid);
          localStorage.setItem("token", res?.token);
          localStorage.setItem("uuid", res?.userResult?.uuid);
          localStorage.setItem("userId", res?.userResult?.userId);
          makeUserOnline({
            userId: encryptMessages(res?.userResult?.userId),
          });
          setLoginData(res);
        } else {
          showToast("error", response?.data?.error?.error_msg);
        }
      } catch {
        showToast("error", "Something went wrong. Please try again.");
      } finally {
        isRequesting.current = false;
      }
    },
    [
      brokerBasicInfo,
      showPhoneNumber,
      callFcmTokenRegister,
      makeUserOnline,
      setLoginData,
    ]
  );

  useEffect(() => {
    if (isSubmitting) return;

    const currentOtp = showPhoneNumber ? `${emailcode}-${phoneOtp}` : emailcode;

    if (showPhoneNumber) {
      if (emailcode?.length === 8 && phoneOtp?.length === 8) {
        if (currentOtp !== lastSubmittedOtp.current) {
          lastSubmittedOtp.current = currentOtp;
          handleSubmit(onSubmit)();
        }
      }
    } else {
      if (emailcode?.length === 8) {
        if (currentOtp !== lastSubmittedOtp.current) {
          lastSubmittedOtp.current = currentOtp;
          handleSubmit(onSubmit)();
        }
      }
    }
  }, [
    emailcode,
    phoneOtp,
    showPhoneNumber,
    handleSubmit,
    isSubmitting,
    onSubmit,
  ]);

  const handleResendOTP = () => {
    resendOtp();
    if (showPhoneNumber) {
      handleSendOtpInSms();
    }
  };

  const resendOtp = async () => {
    setCountdown(300);
    const payload = {
      userId: localStorage.getItem("userId"),
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}user/ResendOTP/registration`,
        payload
      );
      if (response?.data?.error?.error_data === 0) {
        showToast("success", "OTP has been sent to your email");
      } else {
        showToast("error", response?.data?.error?.error_msg);
      }
    } catch {
      showToast("error", "Something went wrong. Please try again.");
    }
  };

  const handleSendOtpInSms = async () => {
    const payload = {
      phone: localStorage.getItem("phoneUsedForRegistration"),
      countryCode: localStorage.getItem("phoneCountryUsedForRegistration"),
    };
    try {
      await sendSmartMobileOtp(payload, "registration");
      return true;
    } catch (error) {
      return false;
    }
  };

  const textFieldStyles = {
    mt: 1,
    input: {
      color: "#333",
      "&::placeholder": {
        color: "#aaa",
        opacity: 1,
      },
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 2,
      "& fieldset": {
        borderColor: "#ccc",
      },
      "&:hover fieldset": {
        borderColor: "#888",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#1976d2",
      },
    },
    "& .MuiFormHelperText-root": {
      mt: 0.5,
    },
    "& label": {
      color: "#333",
      "&.Mui-focused": {
        color: "#1976d2",
      },
    },
  };

  // Keep the input to at most 8 digits. The previous sanitiser ran the value
  // through parseInt, so clearing a partly-typed code wrote the literal string
  // "NaN" into the field.
  const onlyDigits = (e, max) => {
    e.target.value = e.target.value.replace(/\D/g, "").slice(0, max);
  };

  return (
    <div className="auth-page">
      <div className="auth-split">
        <AuthAside exchangeName={brokerBasicInfo?.exchange} />

        <div className="auth-main">
          <div className="auth-masthead">
            <h1 className="auth-title">Verify it's you</h1>
            <p className="auth-subtitle">
              {showPhoneNumber
                ? `Enter the codes sent to your email and to ${phoneNumber}.`
                : "Enter the code sent to your registered email address."}
            </p>
          </div>

          <div className="auth-card">
            <form onSubmit={handleSubmit(onSubmit)} noValidate>
              {showPhoneNumber && (
                <div className="auth-field">
                  <label className="auth-label" htmlFor="otp-phone-code">
                    Phone code
                  </label>
                  <div className="auth-input-wrap">
                    <input
                      id="otp-phone-code"
                      type="text"
                      inputMode="numeric"
                      autoComplete="one-time-code"
                      placeholder="00000000"
                      className={`auth-input auth-input--code${
                        errors.phoneOtp ? " auth-input--invalid" : ""
                      }`}
                      aria-invalid={errors.phoneOtp ? "true" : "false"}
                      {...register("phoneOtp", {
                        required: "Code is required",
                      })}
                      onInput={(e) => onlyDigits(e, 8)}
                    />
                  </div>
                  {errors.phoneOtp && (
                    <span className="auth-error" role="alert">
                      {errors.phoneOtp.message}
                    </span>
                  )}
                </div>
              )}

              <div className="auth-field">
                <label className="auth-label" htmlFor="otp-email-code">
                  Email code
                </label>
                <div className="auth-input-wrap">
                  <input
                    id="otp-email-code"
                    type="text"
                    inputMode="numeric"
                    autoComplete="one-time-code"
                    placeholder="00000000"
                    className={`auth-input auth-input--code${
                      errors.emailcode ? " auth-input--invalid" : ""
                    }`}
                    aria-invalid={errors.emailcode ? "true" : "false"}
                    {...register("emailcode", {
                      required: "Code is required",
                    })}
                    onInput={(e) => onlyDigits(e, 8)}
                  />
                </div>
                {errors.emailcode && (
                  <span className="auth-error" role="alert">
                    {errors.emailcode.message}
                  </span>
                )}
              </div>

              <div className="auth-row">
                <p className="auth-note">
                  {countdown > 0
                    ? `You can request a new code in ${countdown}s`
                    : "Didn't get a code?"}
                </p>
                {countdown === 0 && (
                  <button
                    type="button"
                    className="auth-btn auth-btn--quiet"
                    onClick={handleResendOTP}
                  >
                    Resend
                  </button>
                )}
              </div>

              <button
                type="submit"
                className="auth-btn"
                style={{ marginTop: 20 }}
                disabled={
                  isSubmitting ||
                  (showPhoneNumber
                    ? emailcode?.length !== 8 || phoneOtp?.length !== 8
                    : emailcode?.length !== 8)
                }
              >
                {isSubmitting ? (
                  <>
                    <span className="auth-spinner" aria-hidden="true" />
                    Verifying
                  </>
                ) : (
                  "Verify and continue"
                )}
              </button>

              <p className="auth-note" style={{ marginTop: 16 }}>
                Email delivery can take a little longer depending on your mail
                provider.
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Otp;
